import watchAuth from 'core/providers/AuthProvider/saga';

const coreSaga = [watchAuth()];

export default coreSaga;
